var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeneralMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.795,
    height: 26.073,
    viewBox: "0 0 30.795 26.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_7792",
    "data-name": "Tracciato 7792",
    d: "M862.193,2510.71a1.284,1.284,0,0,0-.651-1.125l-1.024-.588,1.024-.588a1.3,1.3,0,0,0,0-2.25l-13.6-7.805a1.3,1.3,0,0,0-1.291,0l-13.6,7.805a1.3,1.3,0,0,0,0,2.25l1.024.588-1.024.588a1.3,1.3,0,0,0,0,2.25l1.024.588-1.024.587a1.3,1.3,0,0,0,0,2.25l13.6,7.805a1.3,1.3,0,0,0,1.291,0l13.6-7.805a1.3,1.3,0,0,0,0-2.25l-1.024-.588,1.024-.588a1.284,1.284,0,0,0,.651-1.125m-28.664-3.426a.161.161,0,0,1,.083-.144l13.6-7.805a.167.167,0,0,1,.165,0l13.6,7.805a.166.166,0,0,1,0,.288l-13.6,7.805a.168.168,0,0,1-.165,0l-13.6-7.805a.161.161,0,0,1-.083-.144m27.449,6.707a.166.166,0,0,1,0,.288l-13.6,7.805a.168.168,0,0,1-.165,0l-13.6-7.805a.166.166,0,0,1,0-.288l1.6-.917,11.44,6.566a1.3,1.3,0,0,0,1.291,0l11.44-6.566Zm0-3.138-13.6,7.805a.166.166,0,0,1-.165,0l-13.6-7.805a.166.166,0,0,1,0-.288l1.6-.917,11.44,6.565a1.3,1.3,0,0,0,1.291,0l11.44-6.565,1.6.917a.166.166,0,0,1,0,.288",
    transform: "translate(-831.898 -2497.663)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneralMap);
export default __webpack_public_path__ + "static/media/icon-general-map.e60e6169d1838d55aec51ef0ff851482.svg";
export { ForwardRef as ReactComponent };